import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskLines, ease } from "./Reveal";
import { LiteVideo } from "./LiteVideo";
import { CtaButton } from "./CtaButton";
import { VIDEOS } from "../../data/content";

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const bgY = useTransform(scrollYProgress, [0, 1], ["0%", "18%"]);
  const bgScale = useTransform(scrollYProgress, [0, 1], [1.06, 1.16]);
  const videoRotate = useTransform(scrollYProgress, [0, 0.6], [0, 6]);

  return (
    <section ref={ref} data-testid="hero-section" className="relative overflow-hidden bg-[var(--forest)] pb-24 pt-14 md:pb-32 md:pt-20">
      <motion.div style={{ y: bgY, scale: bgScale }} className="absolute inset-0">
        <picture>
          <source media="(max-width: 767px)" srcSet="/assets/iphone_16_pro_max_2.webp" />
          <img src="/assets/frame_3.webp" alt="" className="h-full w-full object-cover object-top opacity-90" />
        </picture>
      </motion.div>
      <div className="absolute inset-0 bg-gradient-to-b from-[#0f1f17]/30 via-[#0f1f17]/40 to-[var(--forest)]" />
      <div className="grain absolute inset-0" />

      <div className="relative mx-auto flex max-w-5xl flex-col items-center px-5 text-center">
        <motion.img
          src="/assets/logo_umbanda_para_todos.webp"
          alt="Umbanda para Todos"
          data-testid="hero-logo"
          className="w-[240px] md:w-[360px]"
          initial={{ opacity: 0, y: 10, filter: "blur(6px)" }}
          animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          transition={{ duration: 1.4, ease }}
        />
        <motion.p
          className="mt-8 text-[11px] font-semibold uppercase tracking-[0.42em] text-[var(--gold)]"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.2, delay: 0.5 }}
        >
          Black Friday · Inscrições abertas
        </motion.p>
        <MaskLines
          lines={["Assista esse", "vídeo primeiro"]}
          delay={0.35}
          className="font-display mt-4 text-4xl leading-[0.98] text-[var(--cream)] sm:text-5xl lg:text-7xl"
        />
        <motion.div
          className="mt-12 w-full [perspective:1400px]"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.4, delay: 0.8, ease }}
        >
          <motion.div style={{ rotateX: videoRotate }}>
            <LiteVideo id={VIDEOS.welcome} title="Sejam bem-vindos! — Umbanda para Todos" testId="hero-video" />
          </motion.div>
        </motion.div>
        <motion.div className="mt-10" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1, delay: 1.2 }}>
          <CtaButton testId="hero-cta-vitalicio" />
        </motion.div>
      </div>
    </section>
  );
};
